<template>
  <div class="LoginSuccess" v-title data-title="登录成功">
    <div class="success fc-primary">
      <van-icon name="checked" size="40px" />
      <div class="pt5">登录成功</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'Login',
  components: {},
  data() {
    return {
      test: '',
    };
  },
  methods: {
  },
});
</script>
<style scoped>
  .LoginSuccess {
    min-height: 100vh;
    background-color: #ffffff;
  }
  .success {
    padding: 30%;
  }
</style>
